let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eEASY")).then(() => parcelRequire('jV3BF'));